// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2753":"d37e8afe","9367":"9d568d0c"}[chunkId] + ".chunk.css";
};